import {
  LayoutDashboard,
  Settings,
  Users,
  UserCog,
  Shield,
  FileText,
  BarChart3,
  PieChart,
  Key,
  Menu,
  Building2,
  Package,
  ShoppingCart,
  Bell,
  MessageCircle,
  LifeBuoy,
  CreditCard,
  Home,
  // Iconos para Develop Kit
  Square,
  FormInput,
  Table,
  PanelTop,
  AlertCircle,
  Smile,
  Type,
  Palette,
  SquareStack,
  Columns3,
  LucideIcon,
} from 'lucide-react';
import React from 'react';

/**
 * Mapa de nombres de iconos desde la BD (nombres exactos de Lucide React) a componentes
 * Ahora la BD usa nombres exactos de Lucide React, así que el mapeo es directo
 */
const iconMap: Record<string, LucideIcon> = {
  // Iconos principales del sistema
  LayoutDashboard,
  Shield,
  BarChart3,
  PieChart,
  Key,
  Menu,
  Settings,
  Users,
  UserCog,
  // Iconos adicionales
  Home,
  FileText,
  Building2,
  Package,
  ShoppingCart,
  Bell,
  MessageCircle,
  LifeBuoy,
  CreditCard,
  // Iconos para Develop Kit
  Square,        // Buttons
  FormInput,     // Forms
  Table,         // DataTables
  PanelTop,      // Modals
  AlertCircle,   // Alerts
  Smile,         // Icons
  Type,          // Typography
  Palette,       // Colors & Develop Kit padre
  SquareStack,   // Cards
  Columns3,      // Tabs
};

/**
 * Obtiene el componente de icono basado en el nombre desde la BD
 * @param iconName - Nombre del icono desde la BD (debe ser el nombre exacto de Lucide React, ej: "LayoutDashboard", "Shield")
 * @returns Componente de icono de Lucide React o null si no se encuentra
 */
export const getIcon = (iconName: string | null | undefined): LucideIcon | null => {
  if (!iconName) return null;

  // Buscar directamente por el nombre exacto (case-sensitive)
  return iconMap[iconName] || null;
};

/**
 * Renderiza un icono basado en el nombre desde la BD
 * @param iconName - Nombre del icono desde la BD
 * @param size - Tamaño del icono (por defecto 20)
 * @param className - Clase CSS adicional
 * @returns Elemento JSX del icono o null
 */
export const renderIcon = (
  iconName: string | null | undefined,
  size: number = 20,
  className?: string
): React.ReactElement | null => {
  const IconComponent = getIcon(iconName);

  if (!IconComponent) return null;

  return <IconComponent size={size} className={className} />;
};

